import React from 'react';
import { ShieldCheckIcon, LockIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { trackAddToCart } from '../utils/metaPixel';
export function ProblemSection() {
  return <section id="comprar" className="w-full py-24 px-4 bg-brand-alt border-y border-brand-card relative overflow-hidden" data-id="element-115">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-brand-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-116" />

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-117">
        <div className="bg-brand-card border-2 border-brand-gold rounded-2xl p-8 md:p-12 shadow-[0_0_50px_rgba(212,168,67,0.15)]" data-id="element-118">
          <h2 className="text-4xl md:text-5xl text-brand-text mb-10" data-id="element-119">
            Toma el Control Hoy Mismo
          </h2>

          <div className="space-y-6 mb-12" data-id="element-120">
            <p className="text-2xl md:text-3xl text-brand-gold font-bold" data-id="element-121">
              $612 en recursos. $12.99 hoy.
            </p>
            <p className="text-lg text-brand-muted max-w-2xl mx-auto" data-id="element-122">
              No porque valgan menos. Sino porque quiero que no tengas excusa
              para no empezar.
            </p>
            <p className="text-lg text-brand-muted max-w-2xl mx-auto" data-id="element-123">
              Porque la verdad es esta: La mayoría de apostadores van a seguir
              pagando grupos VIP. Van a seguir comprando picks que no funcionan.
              Van a seguir apostando sin entender las cuotas, sin gestionar su
              dinero, sin hablar el idioma del mercado.
            </p>
            <p className="text-xl text-brand-red font-bold" data-id="element-124">
              Y van a seguir perdiendo.
            </p>
            <p className="text-lg text-brand-text max-w-2xl mx-auto" data-id="element-125">
              Tú puedes salir de ese ciclo hoy. Por menos de lo que cuesta una
              noche de apuestas impulsivas.
            </p>
          </div>

          <div className="mb-10 bg-brand-bg/50 rounded-xl p-6 border border-brand-gold/10 max-w-md mx-auto" data-id="element-126">
            <p className="text-brand-faint text-lg uppercase tracking-wider mb-4" data-id="element-127">
              Precio de Introducción
            </p>

            {/* Valor Real */}
            <div className="text-xl md:text-2xl text-brand-muted mb-3" data-id="element-128">
              <span className="text-brand-faint" data-id="element-129">Valor real:</span>{' '}
              <span className="font-bold text-brand-text line-through decoration-brand-red/50" data-id="element-130">
                $612 USD
              </span>
            </div>

            {/* Hoy (Today's Price) */}
            <div className="mt-4 relative" data-id="element-131">
              <div className="absolute -top-4 -right-4 bg-brand-red text-white text-sm md:text-base font-bold px-3 py-1 rounded-md uppercase tracking-wide rotate-12 shadow-lg" data-id="element-132">
                -98%
              </div>
              <p className="text-brand-faint text-lg mb-2" data-id="element-133">Hoy:</p>
              <div className="text-6xl md:text-7xl font-bold text-brand-gold font-heading flex items-center justify-center gap-2" data-id="element-134">
                $12.99
              </div>
            </div>
          </div>

          <div className="max-w-md mx-auto space-y-6" data-id="element-135">
            <div data-id="element-136">
              <CTAButton onClick={() => {
              trackAddToCart();
              window.open('https://apuestasinteligentes.com/cart/47692107743453:1', '_blank', 'noopener,noreferrer');
            }} className="w-full text-xl py-5 shadow-[0_0_30px_rgba(212,168,67,0.3)]" data-id="element-137">
                🔓 ACCESO COMPLETO AQUI
              </CTAButton>
              <p className="text-brand-text text-base mt-3 font-bold tracking-wide" data-id="element-138">
                📦 Método Sin-Tipster + 🎁 Bono #1 + 🎁 Bono #2
              </p>
            </div>

            {/* Urgency Message */}
            <div className="text-center py-3" data-id="element-139">
              <p className="text-brand-gold font-bold text-base md:text-lg" data-id="element-140">
                ⚠️ Precio de lanzamiento — disponible por tiempo limitado
              </p>
            </div>

            {/* Guarantee Block */}
            <div className="bg-brand-bg border border-brand-gold/20 rounded-xl p-6 text-left space-y-3 relative overflow-hidden" data-id="element-141">
              <div className="absolute -right-4 -top-4 opacity-10" data-id="element-142">
                <ShieldCheckIcon className="w-24 h-24 text-brand-gold" data-id="element-143" />
              </div>
              <h3 className="text-xl text-brand-text font-bold relative z-10" data-id="element-144">
                ¿Qué pasa si no funciona para ti?
              </h3>
              <p className="text-brand-gold font-bold text-lg relative z-10" data-id="element-145">
                Nada. No arriesgas nada.
              </p>
              <p className="text-brand-muted relative z-10" data-id="element-146">
                Si en los próximos 7 días sientes que esto no fue lo que
                esperabas, escríbeme y te devuelvo cada centavo. Sin preguntas.
                Sin formularios. Sin drama. Porque no quiero tu dinero si no te
                doy valor real.
              </p>
            </div>

            {/* Scarcity Block */}
            <div className="border border-brand-red/30 bg-brand-red/5 rounded-xl p-6 text-left space-y-2" data-id="element-147">
              <h3 className="text-brand-red font-bold flex items-center gap-2" data-id="element-148">
                <span className="text-xl" data-id="element-149">⚠️</span> AVISO IMPORTANTE
              </h3>
              <p className="text-brand-muted text-sm" data-id="element-150">
                Este precio es temporal. Cuando se acabe el periodo de
                lanzamiento, los bonos desaparecen y el precio sube. Si estás
                leyendo esto ahora, el precio sigue activo. Mañana no hay
                garantía.
              </p>
            </div>

            <div className="flex flex-col items-center gap-2 pt-4" data-id="element-151">
              <div className="flex items-center gap-2 text-brand-muted text-sm" data-id="element-152">
                <ShieldCheckIcon className="w-4 h-4 text-brand-green" data-id="element-153" />
                <span data-id="element-154">Acceso instantáneo a la descarga del PDF</span>
              </div>
              <div className="flex items-center gap-2 text-brand-faint text-xs" data-id="element-155">
                <LockIcon className="w-3 h-3" data-id="element-156" />
                <span data-id="element-157">Pago 100% seguro y encriptado</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}